export {
  createTealiumLoaderScript,
  createTealiumLoaderPlugin,
} from "./server/createTealiumLoaderScript";
export * from "./types";
export * from "./tracking/dispatchers";
export * from "./tracking/init";
export { debugLog } from "./tracking/debugLog";
export { CUSTOM_EVENT_TRACK_VIEW_DATA } from "./tracking/viewDataDispatcher";

declare global {
  interface Window {
    REAPackageVersions?: Record<string, string[]>;
  }
}
if (typeof window === "object") {
  window.REAPackageVersions = window.REAPackageVersions || {};
  window.REAPackageVersions["@argonaut/analytics"] =
    window.REAPackageVersions["@argonaut/analytics"] || [];
  window.REAPackageVersions["@argonaut/analytics"].push(
    "__@argonaut/analytics/version__",
  );
}
